import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { ContactoModel } from '../../models/contacto-model';
import { ContactosService } from '../../services/contactos.service';
import { SelectorContactosEditComponent } from '../selector-contactos-edit/selector-contactos-edit.component';
import { ContactosComponent } from '../contactos/contactos.component';

@Component({
  selector: 'app-selector-contactos',
  templateUrl: './selector-contactos.component.html',
  styleUrls: ['./selector-contactos.component.scss']
})
export class SelectorContactosComponent implements OnInit {

  // contactos: ContactoModel[] = [];
  contactos: any[] = [];
  contactoSeleccionado?: ContactoModel;
  dialogConfig: MatDialogConfig;
  contactosPendientes: ContactoModel[] = [];
  private tempIdCounter = 0;
  @Input() prescriptorId: any;
  @Output() contactosActualizados = new EventEmitter<ContactoModel[]>();


  constructor(
    private _contactoService: ContactosService,
    private dialog: MatDialog,
    private _toastr: ToastrService
  ) {

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
    this.dialogConfig.width = '60vw';
    this.dialogConfig.maxHeight = '75vh';
  }

  ngOnInit(): void {
    this.cargarContactos();
  }

  cargarContactos(): void {
    if (this.prescriptorId) {
      this._contactoService.getContactosByPrescriptor(this.prescriptorId).subscribe({
        next: (data: any) => this.contactos = data,
        error: () => this._toastr.error('Error al cargar contactos', 'Cerrar')
      });
    }
  }

  seleccionarContacto(contacto: ContactoModel): void {
    this.contactoSeleccionado = contacto;
  }

  public nuevoContacto() {
    let ref = this.dialog.open(SelectorContactosEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.componentInstance.prescriptorId = this.prescriptorId;
    ref.afterClosed().subscribe(result => {
      if (result) {
        // console.log(result)
        result.isNuevo = true;
        result.tempId = this.generateTempId();
        this.contactosPendientes.push(result);
        this.contactos = [...this.contactos, result];
        // console.log(this.contactos)
        this.contactosActualizados.emit(this.contactosPendientes);
      } else {
        this._contactoService.getContactosByPrescriptor(this.prescriptorId).subscribe((data: any) => { this.contactos = data });
      }
    });
  }


  public modificarContacto() {
    if (!this.contactoSeleccionado) {
      return;
    }

    let dlgRef = this.dialog.open(SelectorContactosEditComponent, this.dialogConfig);
    // console.log(this.contactoSeleccionado)
    dlgRef.componentInstance.id = this.contactoSeleccionado.id;
    dlgRef.componentInstance.isModal = true;
    dlgRef.componentInstance.model = this.contactoSeleccionado;
    dlgRef.componentInstance.prescriptorId = this.prescriptorId;
    dlgRef.componentInstance.tempId = this.contactoSeleccionado.tempId;
    dlgRef.afterClosed().subscribe(result => {

      // console.log(result)
      // console.log(this.contactosPendientes[0])
      if (this.prescriptorId != null && this.prescriptorId != undefined && this.prescriptorId != '') {
        this._contactoService.getContactosByPrescriptor(this.prescriptorId).subscribe((data: any) => { this.contactos = data });
      } else {

        result.tempId = result.tempId || this.generateTempId();
        let index = this.contactosPendientes.findIndex(c => c.tempId == result.tempId);
        if (result != undefined && result.id != 0) {
          index = this.contactosPendientes.findIndex(c => c.id == result.id);
        }
        if (index !== -1) {
          // console.log('Antes:', this.contactosPendientes[index]);
          this.contactosPendientes[index] = { ...this.contactosPendientes[index], ...result };
          this.contactosPendientes = [...this.contactosPendientes]; // Forzar actualización en Angular

          const indexInContactos = this.contactos.findIndex(c => c.tempId === result.tempId);
          if (indexInContactos !== -1) {
            this.contactos[indexInContactos] = { ...this.contactos[indexInContactos], ...result };
          } else {
            this.contactos = [...this.contactos, result];
          }
          this.contactos = [...this.contactos]; // Forzar actualización visual

          // console.log('Después:', this.contactosPendientes[index]);
          this.contactosActualizados.emit(this.contactosPendientes);
        }
      }
      this.contactoSeleccionado = null;
    })
  }

  addContactoExistente() {
    const dialogRef = this.dialog.open(ContactosComponent, {
      width: '800px',
      maxHeight: '50vh',
      data: {
        contactos: this.contactos
      }
    });

    dialogRef.componentInstance.prescriptorId = this.prescriptorId;
    dialogRef.componentInstance.contactosSeleccionados = this.contactos;
    // console.log(this.contactos)

    dialogRef.afterClosed().subscribe((contactosSeleccionados) => {
      if (!contactosSeleccionados) return;
      // console.log(contactosSeleccionados)

      // if (this.prescriptorId !== undefined && this.prescriptorId !== null && this.prescriptorId !== '') {
      //   return;
      // }

      // 1. Eliminar los contactos que fueron desmarcados
      const idsSeleccionados = contactosSeleccionados.map(c => c.id);

      this.contactosPendientes = this.contactosPendientes.filter(
        c => c.id === 0 || idsSeleccionados.includes(c.id)
      );

      this.contactos = this.contactos.filter(
        c => c.id === 0 || idsSeleccionados.includes(c.id)
      );

      // 2. Agregar nuevos contactos que no estaban antes
      const nuevosContactos = contactosSeleccionados.filter(
        nuevo => !this.contactos.some(contacto => contacto.id === nuevo.id)
      );

      this.contactos = [...this.contactos, ...nuevosContactos];
      this.contactosPendientes = [...this.contactosPendientes, ...nuevosContactos];
      // console.log(this.contactosPendientes)
      this.contactosActualizados.emit(this.contactosPendientes);
    });
  }

  deleteRelation(contacto: any): void {
    if (this.prescriptorId !== undefined && this.prescriptorId !== null && this.prescriptorId !== '') {
      this._contactoService.deletePrescriptoContacto(contacto.id, this.prescriptorId).subscribe(x => {
        console.log('contacto eliminado')
      });
    }
    this.contactos = this.contactos.filter(c => c !== contacto);
    this.contactosPendientes = this.contactosPendientes.filter(c => c !== contacto);
    this.contactosActualizados.emit(this.contactosPendientes);
  }

  eliminarContacto(): void {
    if (!this.contactoSeleccionado) return;

    var respuesta = confirm(`¿Quieres eliminar el contacto ${this.contactoSeleccionado.nombre} ${this.contactoSeleccionado.apellidos}?`);

    if (respuesta) {
      if (this.prescriptorId != null && this.prescriptorId != undefined && this.prescriptorId != '') {
        this._contactoService.delete(this.contactoSeleccionado.id, this.prescriptorId).subscribe({
          next: () => {
            this._toastr.success('Contacto eliminado', 'Cerrar');
            this.cargarContactos();
            this.contactoSeleccionado = undefined;
          },
          error: (err) => {
            console.log(err)
            const mensaje = err && err.error && err.error.mensaje ? err.error.mensaje : 'Error al eliminar contacto';
            this._toastr.error(mensaje, 'Cerrar');
          }
        });
      } else {
        this.contactos = this.contactos.filter(c => c !== this.contactoSeleccionado);
        this.contactosPendientes = this.contactosPendientes.filter(c => c !== this.contactoSeleccionado);
        this.contactosActualizados.emit(this.contactosPendientes);
      }
    }
  }

  generateTempId(): number {
    this.tempIdCounter++;
    return this.tempIdCounter;
  }

}

